<template>
  <div>
    <div class="modal" :class="{'is-active':paybillShown}">
      <div class="modal-background" @click="paybillShown = false"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Lipa na Mpesa Info</p>
          <button class="delete" aria-label="close" @click="paybillShown = false"></button>
        </header>
        <section class="modal-card-body">
          <div class="content">
            <p>The following table contains info to use with lipa na mpesa info for your plan</p>
            <table>
              <th></th>
              <th></th>
              <tr>
                <td>Amount You Pay</td>
                <td>{{discountedPrice}}</td>
              </tr>
              <tr>
                <td>Pay bill bussiness Number</td>
                <td>335080</td>
              </tr>
              <tr>
                <td>Pay bill bussiness Name</td>
                <td>Coniunctum Limited</td>
              </tr>
              <tr>
                <td>Account No</td>
                <td>{{user.accountNumber}}</td>
              </tr>
            </table>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="paybillShown = false">Cancel</button>
        </footer>
      </div>
    </div>
    <div class="modal" :class="{'is-active':directPayShown}">
      <div class="modal-background" @click="directPayShown = false"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Direct Pay</p>
          <button class="delete" aria-label="close" @click="directPayShown = false"></button>
        </header>
        <section class="modal-card-body">
          <p>Enter your Safaricom Phone number below and click Pay</p>
          <p
            style="padding-bottom:1em"
          >You will be prompted by mpesa to enter your Mpesa PIN Number to complete your transaction</p>
          <form @submit.prevent="directPay()">
            <div class="control">
              <label class="label">Payment Phone Number:</label>
              <input class="input" type="text" v-model="paynumber">
            </div>
          </form>
        </section>
        <footer class="modal-card-foot">
          <button
            class="button is-success"
            @click="directPay()"
            :class="{'is-loading':initiatingStk}"
          >Pay</button>
          <button class="button" @click="directPayShown = false">Cancel</button>
        </footer>
      </div>
    </div>

    <div class="columns" id="container">
      <div class="column is-centered">
        <div class="login">
          <div class="login-card">
            <div class="card-title">
              <h1>Current Plan</h1>
            </div>
            <div class="content">
              <p
                class="notification is-info"
                :hidden="!disabled"
              >Plan will be available for editing after expiry</p>
              <form @submit.prevent="onSubmit">
                <div class="field">
                  <label class="label">Limit Type</label>
                  <div class="control select">
                    <select class="input" v-model="plan.limitType" :disabled="disabled">
                      <option value="unlimited">Unlimited</option>
                      <!--  <option value="bundle">Bundle</option>-->
                    </select>
                  </div>
                </div>
                <template v-if="plan.limitType === 'bundle'">
                  <div style="padding-bottom:0.5em;">
                    <label class="label">Bundle Size</label>
                  </div>
                  <div>
                    <div class="field has-addons">
                      <div class="control">
                        <input
                          class="input"
                          :class="{'is-danger':errors.bundle}"
                          type="number"
                          value="1"
                          :min="bundle.min"
                          :max="bundle.max"
                          step="0.1"
                          v-model="plan.dataLimit"
                          :disabled="disabled"
                          required
                        >
                      </div>
                      <p class="control">
                        <a class="button is-static">GB</a>
                      </p>
                    </div>
                    <p
                      class="help"
                      :class="{'is-danger':errors.bundle,'is-hidden':!errors.bundle}"
                      v-text="errors.bundle"
                    ></p>
                  </div>
                </template>
                <template v-if="plan.limitType === 'unlimited'">
                  <div style="padding-bottom:0.5em;">
                    <label class="label">Speed</label>
                  </div>
                  <div class="field has-addons">
                    <div class="control">
                      <input
                        class="input"
                        :class="{'is-danger':errors.unlimited}"
                        type="number"
                        value="1"
                        :min="unlimited.min"
                        :max="unlimited.max"
                        step="0.1"
                        v-model="plan.speed"
                        :disabled="disabled"
                        required
                      >
                    </div>
                    <p class="control">
                      <a class="button is-static">Mbit/s</a>
                    </p>
                  </div>
                  <p
                    class="help"
                    :class="{'is-danger':errors.unlimited,'is-hidden':!errors.unlimited}"
                  >{{errors.unlimited}}</p>
                </template>
                <div style="padding-bottom:0.5em;">
                  <label class="label">Valid For</label>
                </div>
                <div class="field has-addons">
                  <p class="control">
                    <input
                      v-if="plan.limitType === 'unlimited'"
                      class="input"
                      :class="{'is-danger':errors.duration}"
                      type="number"
                      :min="unlimited.minDuration"
                      :max="unlimited.maxDuration"
                      value="1"
                      v-model="plan.validityPeriod"
                      :disabled="disabled"
                    >
                    <input
                      v-if="plan.limitType === 'bundle'"
                      class="input"
                      :class="{'is-danger':errors.duration}"
                      type="number"
                      :min="bundle.minDuration"
                      :max="bundle.maxDuration"
                      value="1"
                      v-model="plan.validityPeriod"
                      :disabled="disabled"
                    >
                  </p>
                  <p class="control">
                    <a class="button is-static">Day(s)</a>
                  </p>
                  <!--<p class="control">
                    <span class="select">
                      <select :disabled="disabled" v-model="durationKind">
                        <option value="days">Day(s)</option>
                        <option value="weeks">Week(s)</option>
                        <option value="months">Month(s)</option>
                      </select>
                    </span>
                  </p>-->
                </div>
                <p
                  class="help"
                  :class="{'is-danger':errors.duration,'is-hidden':!errors.duration}"
                  v-text="errors.duration"
                ></p>
                <div class="field">
                  <label class="label">Price</label>
                  <div class="control">
                    <p>
                      Kes
                      <span>{{price}}</span>
                    </p>
                  </div>
                  <div class="control">
                    <p class="label">Discount
                      <span>{{discount}}%</span>
                    </p>
                  </div>
                  <div class="control">
                    <p>Price to Pay: Kes <span>{{discountedPrice}}</span></p>
                  </div>
                </div>
                <div class="field">
                  <p class="control title is-5">
                    <a
                      style="width:100%"
                      class="button is-primary is-small"
                      :disabled="!submitable"
                      @click="updatePlan()"
                      :class="{'is-loading':isSaving,'disabled':!submitable}"
                    >Save This Plan</a>
                  </p>
                </div>
                <div class="field is-grouped is-grouped-centered">
                  <p class="control">
                    <a class="button is-primary is-small disabled" disabled="disabled" :disabled="true" @click="directPayShown = true">Direct Pay</a>
                  </p>
                  <p class="control">
                    <a class="button is-primary is-small" @click="paybillShown = true">Paybill Info</a>
                  </p>
                  <p class="control">
                    <a class="button is-primary is-small" @click="renewPlan">Balance pay</a>
                  </p>
                </div>
                <div class="level">
                  <div class="level-middle">
                    <div class="level-item">
                      <!-- <p class="is-success">Dont have an Account yet ?</p> -->
                    </div>
                  </div>
                  <div class="level-right">
                    <div class="level-item"></div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="login">
          <div class="login-card">
            <div class="card-title">
              <h1>Pending Payments</h1>
            </div>
            <div class="content">
              <table class="table">
                <thead>
                  <tr>
                    <td>Amount</td>
                    <td>Transacting Number</td>
                    <td>Status</td>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="trans in  pending">
                    <tr v-if="!trans.confirmed" :key="trans._id">
                      <td>{{trans.amount}}</td>
                      <td>{{trans.phoneNumber}}</td>
                      <td>
                        <button class="button is-small is-warning">pending...</button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import alertify from "alertifyjs";

export default {
  data: function() {
    return {
      disabled: false,
      submitable: false,
      isSaving: false,
      paybillShown: false,
      directPayShown: false,
      initiatingStk: false,
      paynumber: "", //this.user.phoneNumber
      errors: {
        bundle: "",
        speed: "",
        duration: ""
      }
    };
  },
  methods: {
    ...mapActions(["renewPlan", "getPlan", "populatePricings", "getDiscounts"]),
    isActive() {
      var result = false;
      switch (this.plan.limitType) {
        case "bundle":
          result = new Date(this.plan.dataRemaining) > 0 && new Date(this.plan.expiryDate) > new Date();
          break;
        case "unlimited":
          result = new Date(this.plan.expiryDate) > new Date();
      }
      return result;
    },
    updatePlan() {
      this.isSaving = true;
      axios
        .post("/api/plan/edit", {
          ownerId: this.user._id,
          speed: this.plan.speed,
          dataLimit: this.plan.dataLimit,
          price: this.price,
          discountedPrice: this.discountedPrice,
          limitType: this.plan.limitType,
          validityPeriod: this.plan.validityPeriod,
          autorenew: false
        })
        .then(response => {
          this.isSaving = false;
          var body = response.data;
          if (body.success) {
            alertify.success(body.message);
          } else {
            alertify.error(body.message);
          }
        })
        .catch(error => {
          this.isSaving = false;
          alertify.error("Error Occured Updating Plan");
          console.log(error);
        });
    },
    directPay() {
      var self = this;
      this.initiatingStk = true;
      if (this.paynumber) {
        console.log("posting", this.discountedPrice, this.paynumber, this.session.router)
        axios
          .post("/api/payment/pay", {
            amount: this.discountedPrice,
            phoneNumber: this.paynumber,
            currentLocation: this.session.router
          })
          .then(function(response) {
            var body = response.data;
            self.initiatingStk = false;
            if (body.success) {
              alertify.success(body.message);
            } else {
              alertify.error(body.message);
            }
          })
          .catch(error => {
            this.initiatingStk = false;
            alertify.error("Error initiating direct pay");

            console.log(error);
          });
      } else {
        this.initiatingStk = false;
        alertify.error("Enter your phone number");
      }
    }
  },
  computed: {
    unlimited() {
      var array = this.pricing.filter(function(pricing) {
        return pricing.planType === "unlimited";
      });
      //console.log(array)
      return {
        max: Math.max.apply(
          Math,
          array.map(function(val) {
            return val.speedRange.end;
          })
        ),
        min: Math.min.apply(
          Math,
          array.map(function(val) {
            return val.speedRange.start;
          })
        ),
        maxDuration: Math.max.apply(
          Math,
          array.map(function(val) {
            return val.durationRange.end;
          })
        ),
        minDuration: Math.min.apply(
          Math,
          array.map(function(val) {
            return val.durationRange.start;
          })
        )
      };
    },
    bundle() {
      var array = this.pricing.filter(function(pricing) {
        return pricing.planType === "bundle";
      });
      //console.log(array)
      return {
        max: Math.max.apply(
          Math,
          array.map(function(val) {
            return val.dataRange.end;
          })
        ),
        min: Math.min.apply(
          Math,
          array.map(function(val) {
            return val.dataRange.start;
          })
        ),
        maxDuration: Math.max.apply(
          Math,
          array.map(function(val) {
            return val.durationRange.end;
          })
        ),
        minDuration: Math.min.apply(
          Math,
          array.map(function(val) {
            return val.durationRange.start;
          })
        )
      };
    },
    price() {
      var self = this;
      var result = 0;
      if (this.plan.limitType === "unlimited") {
        var price = self.pricing.filter(function(val, index, arr) {
          return (
            self.plan.speed >= val.speedRange.start &&
            self.plan.speed <= val.speedRange.end &&
            self.plan.validityPeriod >= val.durationRange.start &&
            self.plan.validityPeriod <= val.durationRange.end &&
            val.planType === "unlimited"
          );
        });
        if (price[0]) {
          result = Math.round(
            price[0].priceRate * self.plan.speed * self.plan.validityPeriod
          );
        }
      } else if (this.plan.limitType === "bundle") {
        var price = self.pricing.filter(function(val, index, arr) {
          return (
            self.plan.dataLimit >= val.dataRange.start &&
            self.plan.dataLimit <= val.dataRange.end &&
            self.plan.validityPeriod >= val.durationRange.start &&
            self.plan.validityPeriod <= val.durationRange.end &&
            val.planType === "bundle"
          );
        });
        if (price[0]) {
          result = Math.round(price[0].priceRate * self.plan.dataLimit);
        }
      }
      return result;
    },
    discount(){
      let self = this;
      let result = 0;
      console.log("discounts",self.discounts)
      let discount = self.discounts.filter((value) =>{
        return (self.plan.validityPeriod >= value.rangeStart && self.plan.validityPeriod <= value.rangeEnd)
      })
      if (discount[0]){
        result = discount[0].percentage
      }
      return result;
    },
    discountedPrice(){
       return Math.round((1 - (this.discount/100)) * this.price)
    },

    ...mapState(["user", "plan", "session", "pending", "pricing", "discounts"])
  },
  watch: {
    "plan.dataLimit": function(val) {
      if (val > this.bundle.max || val < this.bundle.min) {
        this.submitable = false;
        this.errors.bundle =
          "data should be between " +
          " " +
          this.bundle.min +
          " to " +
          this.bundle.max;
      } else {
        this.submitable = true;
        this.errors.bundle = "";
      }
    },
    "plan.speed": function(val) {
      if (val > this.unlimited.max || val < this.unlimited.min) {
        this.submitable = false;
        this.errors.unlimited =
          "speed should be between " +
          " " +
          this.unlimited.min +
          " to " +
          this.unlimited.max;
      } else {
        this.submitable = true;
        this.errors.unlimited = "";
      }
    },
    "plan.validityPeriod": function(val) {
      if (this.plan.limitType === "unlimited") {
        if (
          val > this.unlimited.maxDuration ||
          val < this.unlimited.minDuration
        ) {
          this.submitable = false;
          this.errors.duration =
            "Duration should be between " +
            " " +
            this.unlimited.minDuration +
            " to " +
            this.unlimited.maxDuration;
        } else {
          this.submitable = true;
          this.errors.duration = "";
        }
      } else {
        if (val > this.bundle.maxDuration || val < this.bundle.minDuration) {
          this.submitable = false;
          this.errors.duration =
            "Duration should be between " +
            " " +
            this.bundle.minDuration +
            " to " +
            this.bundle.maxDuration;
        } else {
          this.submitable = true;
          this.errors.duration = "";
        }
      }
    }
  },
  created: function() {
    this.getPlan();
    this.getDiscounts();
    //this.populatePricings();
    //console.log(this.unlimited)
    //console.log(this.bundle)
  },
  mounted: function() {
    this.disabled = this.isActive();
  }
};
</script>

<style scoped>
.login {
  background: #f7f7f7;
}
.login-card {
  background: #fff;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.11);
}
.card-title {
  background-color: #00b89c;
  padding: 1em;
}
.card-title h1 {
  color: #fff;
  text-align: center;
  font-size: 1.2rem;
}
.content {
  padding: 1rem 1.5rem 1rem;
}

.not-shown {
  visibility: hidden;
}
.card {
  background: #fff;
  width: 24rem;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.11);
  padding: 3rem 2.5rem 5rem;
}

.sub-btn-container {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}

.input {
  width: 100%;
}

input:focus {
  box-shadow: none;
  border-color: #00d1b2;
}

.disabled {
  pointer-events: none;
}
</style>
